// REACT
import React, { useMemo, useState, forwardRef } from "react";

// COMPONENTS
import DataTable from "react-data-table-component";
import Filter from "./Filter";
import Loader from "components/shared/loader";

// BOOTSTRAP
import { Col, Form } from "react-bootstrap";

// FORMATTING & INTERNATIONALIZATION
import { FormattedMessage } from "react-intl";

// STYLES
import styles from "./styles/style.module.scss";

const TableControl = ({ data, loading, columns, title, subTitle }) => {
    const BootyCheckbox = new forwardRef(({ onClick, ...rest }, ref) => (
        <Form.Check>
            <input
                htmlFor="booty-check"
                type="checkbox"
                className="form-check-input"
                ref={ref}
                onClick={onClick}
                {...rest}
            />
            <label className="form-check-label" id="booty-check" />
        </Form.Check>
    ));

    const [filterText, setFilterText] = useState("");
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

    const filteredItems = data?.filter(
        (item) =>
            JSON.stringify(item)
                .toLowerCase()
                .indexOf(filterText.toLowerCase()) !== -1
    );

    const subHeaderComponent = useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);
                setFilterText("");
            }
        };

        return (
            <Filter
                onFilter={(event) => setFilterText(event.target.value)}
                onClear={handleClear}
                filterText={filterText}
            />
        );
    }, [filterText, resetPaginationToggle]);

    return (
        <>
            <div className={styles["table-control"]}>
                <div className="table-wrapper">
                    <Col xl={6} md={12} xs={12}>
                        <div className="table-head">
                            {title && (
                                <h4>
                                    <FormattedMessage id={title || ""} />{" "}
                                </h4>
                            )}
                            {subTitle && (
                                <p>
                                    {" "}
                                    <FormattedMessage id={subTitle || ""} />
                                </p>
                            )}
                        </div>
                    </Col>
                    <div className="table-body">
                        <DataTable
                            columns={columns}
                            data={filteredItems}
                            progressPending={loading}
                            progressComponent={<Loader />}
                            defaultSortField="name"
                            selectableRows
                            subHeader
                            subHeaderComponent={subHeaderComponent}
                            selectableRowsComponent={BootyCheckbox}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

export default TableControl;
